export default {
  services: {
    name: 'บริการ',
    fields: {
      name: 'บริการ',
      title_th: 'ชื่อบริการ (ไทย)',
      title_en: 'ชื่อบริการ (อังกฤษ)',
      title: 'ชื่อบริการ (ไทย/อังกฤษ)',
      description_th: 'รายละเอียดบริการ (ไทย)',
      description_en: 'รายละเอียดบริการ (อังกฤษ)',
      short_description_th: 'รายละเอียดบริการโดยย่อ (ไทย)',
      short_description_en: 'รายละเอียดบริการโดยย่อ (อังกฤษ)',
      green_card_description: 'รายละเอียด Green Card',
      red_card_description: 'รายละเอียด Red Card',
      ev_card_description: 'รายละเอียด EV Card',
      type: { label: 'ประเภท', choices: { normal: 'ปกติ', promotion: 'โปรโมชั่น' } },
      images: 'รูปภาพประกอบ',
      thumbnail: 'รูป thumbnail',
      youtube_link: 'Youtube Link',
      start_date: 'วันที่เริ่มต้น',
      end_date: 'วันที่สิ้นสุด',
      // booking_service_key: 'Booking Key',
      booking_service_key: 'Booking Service',
    },
    create: { title: 'สร้างบริการ', success: 'สร้างสำเร็จ' },
    edit: { title: 'แก้ไขบริการ', success: 'แก้ไขสำเร็จ' },
    show: { title: 'แสดงบริการ' },
  },
}
